@if (!showBarcodeInformation) {
  <td colspan="11">&nbsp;</td>
}

@if (showBarcodeInformation) {
  <td class="add-barcode-row__description" colspan="7">
    <label
      for="descriptionInput"
      i18n="Barcode: description label@@table.header.description"
      >Description</label
      ><br />
      @if (barcodeDisabled) {
        <span>{{ descriptionControl.value }}</span>
      }
      @if (!barcodeDisabled) {
        <input
          [formControl]="descriptionControl"
          autocomplete="off"
          id="descriptionInput"
          type="text"
          />
      }
      @if (
        descriptionControl &&
        descriptionControl.invalid &&
        descriptionControl.touched
        ) {
        <p
          class="form-input-error"
          i18n="Barcode error: description empty@@barcode.description.error"
          >
      Please enter a description
    </p>
      }
    </td>
    <td class="add-barcode-row__barcode">
      <label for="barcodeInput" i18n="Barcode: barcode label@@order.barcode"
        >Barcode</label
        ><br />
        @if (barcodeDisabled) {
          <span>{{ barcodeControl.value }}</span>
        }
        @if (!barcodeDisabled) {
          <input
            [formControl]="barcodeControl"
            autocomplete="off"
            id="barcodeInput"
            type="text"
            />
        }
        @if (barcodeControl && barcodeControl.invalid && barcodeControl.touched) {
          <p
            class="form-input-error"
            i18n="Barcode error: barcode empty@@barcode.barcode.error"
            >
      Please enter a barcode
    </p>
        }
      </td>
      <td class="add-barcode-row__sales-price">
        <label
          for="salesPriceInput"
          i18n="Barcode: sales price label@@barcode.salesprice"
          >Sales price</label
          ><br />
          @if (barcodeDisabled) {
            <span>{{ salesPriceControl.value }}</span>
          }
          @if (!barcodeDisabled) {
            <input
              (blur)="onSalesPriceBlur()"
              [formControl]="salesPriceControl"
              autocomplete="off"
              id="salesPriceInput"
              type="text"
              />
          }
          @if (
            salesPriceControl &&
            salesPriceControl.invalid &&
            salesPriceControl.touched
            ) {
            <p
              class="form-input-error"
              i18n="Barcode error: sales price invalid@@barcode.salesprice.error"
              >
      Please enter a valid sales price
    </p>
          }
        </td>
        <td class="add-barcode-row__save" colspan="2">
          @if (!barcodeDisabled) {
            @if (!loading && !confirmed) {
              <button
                (click)="confirmBarcode()"
                class="button theme-btn-primary barcode-button-confirm"
                type="button"
                >
                <svg class="icon-save text-green" height="21" width="21">
                  <use xlink:href="/images/icons/svg-sprite.svg#confirmation"></use>
                </svg>
              </button>
            }
            @if (loading && !confirmed) {
              <button
                class="button button--product-added theme-btn-primary barcode-button-confirm"
                type="button"
                >
                <svg class="icon-spinner" height="14" width="14">
                  <use xlink:href="/images/icons/svg-sprite.svg#spinner"></use>
                </svg>
              </button>
            }
            @if (confirmed && !loading) {
              <button
                class="button--text barcode-button-confirm"
                type="button"
                >
                <span class="theme-success-text-color">
                  <svg class="icon-save text-green" height="21" width="21">
                    <use xlink:href="/images/icons/svg-sprite.svg#confirmation"></use>
                  </svg>
                </span>
              </button>
            }
          }
        </td>
      }
